import { withStyles } from '@material-ui/core';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import PF2MCustomDragLayer from '~/components/PF2MCustomDragLayer';
import PF2MTabs from '~/components/PF2MTabs';
import DestinationsTab from './DestinationsTab';
import DestinationsTabV2 from './DestinationsTabV2';
import OriginsTab from './OriginsTab';
import OriginsTabV2 from './OriginsTabV2';
import useTabletConfiguration from '~/services/tabletConfiguration';
import styles from './styles';

const DispatchControl = () => {
  const [selectedTab, setSelectedTab] = useState(0);

  const { t: translate } = useTranslation();
  const { value: dispatchRealTime } = useTabletConfiguration('dispatch_real_time');
  const chatList = useSelector(state => (state.chat?.chatList));


  const tabs = [
    { key: 0, label: translate('common:Origins') },
    { key: 1, label: translate('common:Destinations') },
  ];
  const handleChange = (event, value) => {
    setSelectedTab(value);
  };

  return (
    <>
      <PF2MTabs
        value={selectedTab}
        onChange={handleChange}
        indicatorColor="primary"
        textColor="primary"
        chatIndex={3}
        readStatus={
          chatList ? Object
            .values(chatList)
            .reduce((acc, e) => (e.isReaded ? acc : false), true) : true
        }
        hideSyncButton
      >
        {tabs}
      </PF2MTabs>

      {selectedTab === 0 ? (
        <>
          {dispatchRealTime === '1' ? <OriginsTabV2 /> : <OriginsTab />}
          <PF2MCustomDragLayer />
        </>
      ) : null}
      {selectedTab === 1 ? (
        <>
          {dispatchRealTime === '1' ? <DestinationsTabV2 /> : <DestinationsTab />}
          <PF2MCustomDragLayer />
        </>
      ) : null}
    </>
  );
};

export default withStyles(styles)(DispatchControl);
